export default __webpack_public_path__ + "images/value_tags/silicone_free-d4be5cf49f71aecbf6c71a4645067459.svg";